// removed by extract-text-webpack-plugin
module.exports = {"inbox":"Inbox_inbox--3hxam","inboxCaption":"Inbox_inboxCaption--3aUTD","inboxButton":"Inbox_inboxButton--2dwNk"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/components/Inbox/Inbox.scss
// module id = 2393
// module chunks = 11